import type { BulletinStampBucket } from './bulletin';

/** 掲示板スタンプ種別（API・DB と一致） */
export const BULLETIN_STAMP_TYPES = [
  'thank_you',
  'acknowledged',
  'please',
  'understood',
  'like',
  'suu',
  'gyoi',
] as const;

export type BulletinStampType = (typeof BULLETIN_STAMP_TYPES)[number];

/** ラベルと画像ファイル名（画像は public/bulletin_stamps に配置） */
export const BULLETIN_STAMP_META: Record<
  BulletinStampType,
  { label: string; imageFile: string }
> = {
  thank_you: { label: 'ありがとうございます', imageFile: 'thank_you.png' },
  acknowledged: { label: '承知しました', imageFile: 'acknowledged.png' },
  please: { label: 'お願いします', imageFile: 'please.png' },
  understood: { label: '分かりました', imageFile: 'understood.png' },
  like: { label: 'いいね！', imageFile: 'like.png' },
  suu: { label: 'スーを差し上げます', imageFile: 'suu.png' },
  gyoi: { label: '御意', imageFile: 'gyoi.png' },
};

export function bulletinStampPublicUrl(imageFile: string): string {
  const prefix = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${prefix}/bulletin_stamps/${imageFile}`;
}

/** API 応答をマージするための空スタンプ集計 */
export function emptyBulletinStampsBuckets(): Record<BulletinStampType, BulletinStampBucket> {
  return BULLETIN_STAMP_TYPES.reduce(
    (acc, t) => {
      acc[t] = { count: 0, users: [] };
      return acc;
    },
    {} as Record<BulletinStampType, BulletinStampBucket>
  );
}
